import Flickity from "flickity-imagesloaded";

class GalleryCarousel {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		self.carousel = new Flickity( self.elem, {
			wrapAround: true,
			cellAlign: 'left',
			imagesLoaded: true,
			watchCSS: true
		});		

		self.viewPort = self.elem.querySelector('.flickity-viewport');

		window.addEventListener("resize", () => {
			self.carousel.resize();
			self.viewPort.style.height = null;
		});
	}


}

export default GalleryCarousel;